import React, { useEffect, useState } from 'react';
import { AssetsTaskProps, PageType, TaskFieldType } from '../types';
import { useAsyncEffect, useSetState } from 'ahooks';
import { getTaskPage, getPageLowCode, getTaskPropertySettings, getTaskAdd } from '@/api/scene';
import { ROUTERSTATUSMAPPING } from '../AssetTask/consts';
import { Empty } from 'antd';
import { getMaxFloor, Api as FetchAPI } from '@/utils';
import Cascade from '@/asset/AssetTask/templates/Cascade';
import { findAssetCascadeData, getTaskRules } from '@/api/cascade';
import { cascadeTransformValues } from '../AssetTask/service';
import useMetaStore, { useMeta } from '@/store/useMetaStore';
import useValuesStore, { useValues } from '@/store/useValuesStore';
import { copyPageValue } from '../AssetTask/templates/Cascade/effect/useCopyPage';
import StoreContext from '@/store/context';


function AssetAdd(props: AssetsTaskProps) {
  const {
    taskId,
    recordId,
    utils,
  } = props;

  (FetchAPI as any).headers = { taskId };
  const pageType = 'edit';

  const meta = useMetaStore();
  const { setMetaInfo, myRoles } = meta;
  const { resetValue, values, pageRules } = useValuesStore();
  const [isReady, setIsReady] = useState(false);

  useAsyncEffect(async () => {
    if (!taskId || !pageType) {
      console.warn('not find taskId or pageType', props);
      return;
    }
    const fieldIdList = utils?.queryParams?.fields?.split(',');
    // 获取模板接口
    const taskInfo = await getTaskAdd({ taskId, fieldIdList });
    taskInfo.maxTag = getMaxFloor(taskInfo?.relationTree || []);
    const moduleIdList = taskInfo.modules?.map((item) => item.moduleID);
    // 获取任务下的属性
    const resultTaskFields = await getTaskPropertySettings(taskId, moduleIdList).catch((e) => {
      console.error(e);
    }) as TaskFieldType[];
    const moduleTaskField: Record<string, TaskFieldType[]> = {};
    taskInfo.modules?.forEach((module) => {
      moduleTaskField[module.handle] = resultTaskFields?.filter((field) => field.logic_entity_id === module.moduleID) || [];
    });
    // 获取页面的配置
    const pageConfig = await getPageLowCode({ pageStatus: pageType, pageKey: taskId });
    pageConfig.createPageConfig.hideSubmit = true;
    pageConfig.createPageConfig.hideClose = true;
    pageConfig.freeBtnConfig = [];
    Object.keys(pageConfig?.pageModuleConfig || {}).forEach((itemKey) => {
      pageConfig.pageModuleConfig[itemKey].hideRowDelete = true;
      pageConfig.pageModuleConfig[itemKey].hideListAdd = true;
      pageConfig.pageModuleConfig[itemKey].canImport = false;
    });
    // setStore
    setMetaInfo({
      taskInfo,
      moduleTaskField,
      taskId,
      moduleList: taskInfo.modules.filter((item) => {
        return !pageConfig.pageModuleConfig?.[item.handle].isFileModule;
      }),
      utils,
      pageType: ROUTERSTATUSMAPPING[pageType],
      recordId,
      pageConfig,
    });


    // 拉页面的数据
    if (pageType === 'list') {
      resetValue({}, myRoles);
    } else if (ROUTERSTATUSMAPPING[pageType] === 'add') {
      // 获取复制信息
      const pageInitValues = await copyPageValue({ pageType, pageConfig, utils, taskInfo });
      resetValue({ ...pageInitValues }, myRoles);
    } else {
      const res = await findAssetCascadeData({ taskId, recordId, version: utils?.queryParams?.version });
      const values = cascadeTransformValues(res.response, taskInfo.modules);
      resetValue({ ...values }, myRoles);
    }

    setIsReady(true);
  }, [taskId, pageType]);


  if (!isReady) {
    return null;
  }
  console.log('Values', values, pageRules);
  console.log('Meta', meta);

  if (!utils?.queryParams?.fields) {
    return <div>没有补录字段</div>;
  }

  if (recordId === '0' || Object.keys(meta.pageConfig || {}).length === 0) {
    return <Empty description="数据出现错误,请联系管理员处理" />;
  }

  return (
    <Cascade />
  );
}

export default function StoreContextWarp(props: any) {
  const values = useValues();
  const meta = useMeta();
  return (
    <StoreContext.Provider value={{ values, meta }}>
      <AssetAdd {...props} />
    </StoreContext.Provider>
  );
}
